/*
 *   File : manage-product.js
 *   Author : https://evoqins.com
 *   Description : Manage product page
 *   Integrations : NA
 *   Version : 1.0.0
*/

import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import draftToHtml from 'draftjs-to-html';
import { toast } from 'react-toastify';
import { EditorState, convertToRaw, ContentState } from 'draft-js';

//styles
import styles from "../../../Style/Component/input.module.scss";

//Custom components
import { Icon } from '../../../Component/Icon';
import { CustomEditor, CustomFileUpload, CustomRadio, CustomSelectBox, CustomTextInput, TagSelector, TextArea } from '../../../Component/FormElements';
import { APIService, AWSService } from '../../../Service';
import { FileUploader } from 'react-drag-drop-files';
import { PrimaryButton, SecondaryButton, TextButton } from '../../../Component/Buttons';
import { ManageCategoryModal } from "../../../Component/Modal";
import { Modal } from 'bootstrap';


const PRODUCT_USAGE = [
    { id: 2, label: "Interior" },
    { id: 1, label: "Exterior" }
];

const DISPLAY_TIME = [
    { id: 1, label: "1 Sec" },
    { id: 2, label: "2 Sec" },
    { id: 3, label: "3 Sec" },
    { id: 4, label: "4 Sec" },
    { id: 5, label: "5 Sec" },
    { id: 6, label: "6 Sec" }
];

const CatalogManageProduct = () => {

    const navigate = useNavigate();
    const { state } = useLocation();

    const errorFocusRef = useRef({});


    const [selectedProductUsage, setSelectedProductUsage] = useState(2);

    const [productName, setProductName] = useState("");
    const [productNameError, setProductNameError] = useState("");

    const [filterData, setFilterData] = useState({});

    const [productType, setProductType] = useState(null);
    const [productTypeError, setProductTypeError] = useState("");

    const [surface, setSurface] = useState(null);
    const [surfaceError, setSurfaceError] = useState("");

    const [finish, setFinish] = useState(null);
    const [finishError, setFinishError] = useState("");

    const [brand, setBrand] = useState(null);
    const [brandError, setBrandError] = useState("");

    const [tag, setTag] = useState("");
    const [tagError, setTagError] = useState("");

    const [highlightedTag, setHighlightedTag] = useState(1);

    const [thumbnail, setThumbnail] = useState(null);
    const [thumbnailError, setThumbnailError] = useState("");
    const [errorUpdate, setErrorUpdate] = useState(false);

    const [thumbnailLoader, setThumbnailLoader] = useState(false);

    const [productImages, setProductImages] = useState([null]);

    const [productImageErrors, setProductImageErrors] = useState([]);
    const [productImageLoaders, setProductImageLoaders] = useState([]);

    const [productImageErrorUpdate, setProductImageErrorUpdate] = useState([]);

    const [selectedTime, setSelectedTime] = useState(1);

    const [editor, setEditor] = useState(() => EditorState.createEmpty());
    const [editorData, setEditorData] = useState(null);
    const [editorError, setEditorError] = useState("");


    const [productTitle, setProductTitle] = useState("");
    const [productDescription, setProductDescription] = useState("");

    const [brochure, setBrochure] = useState("");
    const [brochureDescription, setBrochureDescription] = useState("");
    const [brochureFile, setBrochureFile] = useState(null);
    const [brochureFileLoader, setBrochureFileLoader] = useState(false);
    const [brochureFileErrorUpdate, setBrochureFileLoaderErrorUpdate] = useState(false);

    const [enableProductDownload, setEnableProductDownload] = useState(true);

    const [productFeature, setProductFeature] = useState([{ cover_image_url: null, title: "", description: "" }]);

    const [linkTitle, setLinkTitle] = useState("");
    const [redirectionLink, setRedirectionLink] = useState("");


    const [dataSheetFile, setDataSheetFile] = useState(null);
    // const [dataSheetFileLoader, setDataSheetFileLoader] = useState(null);


    const [productOverview, setProductOverview] = useState([""]);

    const [dataSheetsData, setDataSheetsData] = useState([{ title: "", description: "", file_url: null, enable_download: true }]);
    const [dataSheetFileLoader, setDataSheetFileLoader] = useState([]);
    const [dataSheetFileErrorUpdate, setDataSheetFileErrorUpdate] = useState([]);

    const [manageCategoryModal, setManageCategoryModal] = useState(false);
    const [dataSheetEdit, setDataSheetEdit] = useState(false);

    const [category, setCategory] = useState([]);
    const [categoryEditData, setCategoryEditData] = useState({});
    const [editIndex, setEditIndex] = useState(null);

    console.log("category", category);


    useEffect(() => {
        if (state !== null) {
            if (state?.editData) {

                let edit_data = state?.editData;

                console.log("edit_data", edit_data);
                setSelectedProductUsage(edit_data.category_id)
                setProductName(edit_data.name);

                setProductType({ value: edit_data.product_type_id, label: edit_data.product_type });
                setSurface({ value: edit_data.surface_id, label: edit_data.surface });
                setFinish({ value: edit_data.finish_id, label: edit_data.finish });
                setBrand({ value: edit_data.brand, label: edit_data.brand });

                // if (edit_data?.highlight_tag?.length !== 0) {
                //     let updated_tag = edit_data.highlight_tag.map((data) => ({
                //         value: data,
                //         label: data
                //     }))

                //     setTag(updated_tag);
                // }

                if (edit_data.highlight_enabled === true) {
                    setHighlightedTag(1);
                } else {
                    setHighlightedTag(2);
                }

                setTag(edit_data.highlight_tag ?? "");


                setThumbnail(edit_data.thumbnail_url);

                if (edit_data.product_images !== null && edit_data.product_images?.length !== 0) {
                    setProductImages(edit_data.product_images);
                }

                setSelectedTime(edit_data.display_time);

                if (edit_data.product_overview?.length !== 0) {
                    setProductOverview(edit_data.product_overview ?? [""]);
                }

                setProductTitle(edit_data.product_title ?? "");
                setProductDescription(edit_data.description ?? "");
                setBrochure(edit_data.brochure ?? "");
                setBrochureDescription(edit_data.brochure_description ?? "");
                setEnableProductDownload(edit_data.brochure_downloadable);

                setBrochureFile(edit_data.brochure_url ?? null);

                if (edit_data.features.length !== 0) {
                    setProductFeature(edit_data.features);
                }

                setLinkTitle(edit_data.redirection_title ?? "");
                setRedirectionLink(edit_data.redirection_url ?? "");

                if (edit_data.datasheets?.length !== 0) {
                    setDataSheetsData(edit_data.datasheets)
                }

                if (edit_data.categories) {
                    setCategory(edit_data.categories ?? [])
                }
            }
        }
    }, [state]);

    useEffect(() => {
        _getFilterData();
    }, []);

    useEffect(() => {
        setProductNameError("");
    }, [productName]);

    useEffect(() => {
        setProductTypeError("");
    }, [productType]);

    useEffect(() => {
        setSurfaceError("");
    }, [surface]);

    useEffect(() => {
        setFinishError("");
    }, [finish]);

    useEffect(() => {
        setBrandError("");
    }, [brand]);

    useEffect(() => {
        setTagError("");
    }, [tag]);

    useEffect(() => {
        setEditorError("");
    }, [editor]);

    useEffect(() => {
        setThumbnailError("");

        setErrorUpdate(prevValue => !prevValue);

    }, [thumbnail]);

    useEffect(() => {
        setBrochureFileLoaderErrorUpdate(prev => !prev)
    }, [brochureFile]);

    // useEffect(() => {
    //     setDataSheetFileErrorUpdate(prev => !prev)
    // }, [dataSheetFile]);


    useEffect(() => {
        if (manageCategoryModal === true) {
            const modal = new Modal(document.getElementById('manage-category-modal'));
            modal.show();
        }
    }, [manageCategoryModal]);

    // handle upload thumbnail
    const _handleUploadThumbnail = (url) => {
        setThumbnailLoader(true);
        _getPresignedUrl(url, 1);
    };



    const _handleUploadProductImages = (url, index) => {

        setProductImageLoaders(prev => {
            const copy = [...prev];
            copy[index] = true;
            return copy;
        });

        _getPresignedUrl(url, 2, index);
    };

    const _handleAddMoreProductImage = () => {
        setProductImages(prev => [...prev, null]);

        setProductImageErrors(prev => [...prev, false]);
        setProductImageLoaders(prev => [...prev, false]);
        setProductImageErrorUpdate(prev => [...prev, false]);
    };

    const _handleDeleteProductImage = (index) => {
        setProductImages(prev => prev.filter((_, i) => i !== index));

        setProductImageErrors(prev => prev.filter((_, i) => i !== index));
        setProductImageLoaders(prev => prev.filter((_, i) => i !== index));
        setProductImageErrorUpdate(prev => prev.filter((_, i) => i !== index));
    };

    // handle edit editor
    const _handleEditorChange = (data) => {
        setEditor(data);
        _getHtmlFormat();
    };

    const _handleOverviewChange = (value, index) => {
        const updated = [...productOverview];
        updated[index] = value;
        setProductOverview(updated);
    };

    const _addOverview = () => {
        setProductOverview([...productOverview, ""]);
    };

    const _removeOverview = (index) => {
        const updated = productOverview.filter((_, i) => i !== index);
        setProductOverview(updated.length ? updated : [""]);
    };

    // convert html format 
    const _getHtmlFormat = () => {
        const content = editor.getCurrentContent();
        const raw_content = convertToRaw(content);
        const html_content = draftToHtml(raw_content);

        setEditorData({ content: html_content });
    };

    // handle upload 
    const _handleUploadBrochure = (url) => {
        setBrochureFileLoader(true);
        _getPresignedUrl(url, 3);
    };

    const _handleProductFeature = (e, field, index) => {
        if (field === "cover_image_url") {
            _getPresignedUrl(e, 4, index, field);
            return;
        }

        setProductFeature(prev => {
            const copy = [...prev];
            copy[index][field] = e;
            return copy;
        });
    };

    const _handleAddNewFeature = () => {
        setProductFeature(prev => [
            ...prev,
            { cover_image_url: null, title: "", description: "" }
        ]);
    };

    const _handleDeleteFeature = (index) => {
        setProductFeature(prev => prev.filter((_, i) => i !== index));
    };

    // handle upload 
    // const _handleUploadDataSheet = (url) => {
    //     setDataSheetFileLoader(true);
    //     _getPresignedUrl(url, 5);
    // };


    const _handleChangeDataSheet = (value, field, index) => {

        if (field === "file_url") {
            setDataSheetFileLoader(prev => {
                const loaders = [...prev];
                loaders[index] = true;
                return loaders;
            });

            setDataSheetFileErrorUpdate(prev => {
                const updated = [...prev];
                updated[index] = "";
                return updated;
            });

            _getPresignedUrl(value, 6, index, field);
            return;
        }

        setDataSheetsData(prev => {
            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                [field]: value
            };
            return updated;
        });
    };

    const _addDataSheet = () => {
        setDataSheetsData(prev => [
            ...prev,
            { title: "", description: "", file_url: null, enable_download: true }
        ]);
    };


    const _removeDataSheet = (index) => {
        setDataSheetsData(prev =>
            prev.length > 1
                ? prev.filter((_, i) => i !== index)
                : prev
        );
    };





    const _handleCategory = (value, field, index) => {

        if (field === "file_url") {
            _getPresignedUrl(value, 7, index, field);
            return;
        }

        setCategory(prev => {
            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                [field]: value
            };
            return updated;
        });
    };

    const _handleCategorySuccess = (newData) => {
        if (dataSheetEdit && editIndex !== null) {
            // Edit existing category
            setCategory(prev => {
                const updated = [...prev];
                updated[editIndex] = {
                    ...updated[editIndex],
                    ...newData[0],
                };
                return updated;
            });
        } else {
            setCategory(prev => [...prev, ...newData]);
        }

        setManageCategoryModal(false);
        setDataSheetEdit(false);
    };

    const _handleDeleteCategory = (index) => {
        setCategory(prev => prev.filter((_, i) => i !== index));
    };



    // handle focus error
    const _focusError = (field) => {
        if (errorFocusRef.current[field]) {
            errorFocusRef.current[field].scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    // handle add product
    const _handleAddProduct = () => {
        let is_valid = true;
        let error_field = [];


        if (productName.trim().length === 0) {
            setProductNameError("Please provide product name");
            error_field.push('productName');

            is_valid = false;
        }

        if (productType === null) {
            setProductTypeError("Please provide product type");

            error_field.push('productType');

            is_valid = false;
        }

        if (surface === null) {
            setSurfaceError("Please provide surface");
            error_field.push('surface');

            is_valid = false;
        }

        if (finish === null) {
            setFinishError("Please provide finish");
            error_field.push('finish');

            is_valid = false;
        }

        if (brand === null) {
            setBrandError("Please provide product brand");
            error_field.push('brand');

            is_valid = false;
        }

        if (thumbnail === null) {
            setThumbnailError("Please provide thumbnail");
            error_field.push('thumbnail');

            is_valid = false;
        }

        if (highlightedTag === 1) {
            if (tag.length === 0) {
                setTagError("Please provide highlight tag");
                error_field.push('tag');
                is_valid = false;
            }
        }

        const valid_product_overview = productOverview.some(v => v.trim() === "");

        const updated_product_information =
            !productTitle?.length ||
            !productDescription?.length ||
            !brochure?.length ||
            !brochureDescription?.length ||
            !brochureFile;

        const updated_product_feature = productFeature.some(feature =>
            !feature.cover_image_url ||
            feature.title.trim() === "" ||
            feature.description.trim() === ""
        );

        const updated_data_sheet = dataSheetsData.some(sheet =>
            !sheet.file_url ||
            sheet.title.trim() === "" ||
            sheet.description.trim() === ""
        );

        if (is_valid === true) {
            if (valid_product_overview) {
                toast.dismiss();
                toast.error("Please provide product overview", {
                    type: "error",
                    className: "e-toast",
                });
                error_field.push('productOverview');
            } else if (updated_product_information) {
                toast.dismiss();
                toast.error("Please provide product information", {
                    type: "error",
                    className: "e-toast",
                });
                error_field.push('productInformation');
            } else if (updated_product_feature) {
                toast.error("Please complete all product features (image, title & description)");
                error_field.push('productFeature');
            } else if (linkTitle.length === 0 || redirectionLink.length === 0) {
                toast.error("Please provide link title and redirection url");
                error_field.push('link');
            } else if (updated_data_sheet) {
                toast.error("Please complete all data sheet (title , description & file)");
                error_field.push('dataSheet');
            }
        }


        if (error_field.length > 0) {
            _focusError(error_field[0]);
        } else if (is_valid === true) {
            _manageCatalogue();
        }
    };

    // get presigned url
    async function _getPresignedUrl(file, type, index = null, field = null) {
        let is_post = true;
        let url = 'general/file-upload';
        let data = {
            "file": file.name,
            "is_public": true
        };
        try {
            let response = await APIService(is_post, url, data);

            if (response.status_code == 200) {
                let aws_fields = response.data.upload_info.fields;
                let aws_url = response.data.upload_info.url;

                try {
                    let aws_response = await AWSService(aws_fields, file, aws_url);
                    if (aws_response.status == 'ok') {
                        if (type === 1) {
                            setThumbnail(response.data.view_info);

                        } else if (type === 2) {
                            setProductImages(prev => {
                                if (index !== null) {
                                    const updated = [...prev];
                                    updated[index] = response.data.view_info;   // replace at index
                                    return updated;
                                }
                                // return [...prev, response.data.view_info];      // push new one
                            });
                        } else if (type === 3) {
                            setBrochureFile(response.data.view_info);
                        } else if (type === 4) {
                            setProductFeature(prev => {
                                const updated = [...prev];
                                updated[index].cover_image_url = response.data.view_info;
                                return updated;
                            });
                        }
                        else if (type === 5) {
                            setDataSheetFile(response.data.view_info);
                        }
                        else if (type === 6) {

                            setDataSheetsData(prev => {
                                const updated = [...prev];
                                updated[index].file_url = response.data.view_info;
                                return updated;
                            });
                        }
                        else if (type === 7) {

                            setCategory(prev => {
                                const updated = [...prev];
                                updated[index].file_url = response.data.view_info;
                                return updated;
                            });
                        }
                    } else {
                        toast.dismiss();
                        toast.error(aws_response.message, {
                            type: "error",
                            className: "e-toast",
                        });
                    }
                } catch (err) {
                    console.log("error")
                }
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
        } catch (err) {
        }
        setThumbnailLoader(false);
        setDataSheetFileLoader(prev => {
            const loaders = [...prev];
            loaders[index] = false;
            return loaders;
        });

        setProductImageErrors(prev => {
            const copy = [...prev];
            copy[index] = false;
            return copy;
        });

        setProductImageLoaders(prev => {
            const copy = [...prev];
            copy[index] = false;
            return copy;
        });

        setBrochureFileLoader(false);
    };

    const [createLoader, setCreateLoader] = useState(false);

    // API - Get Filter data
    const _getFilterData = () => {
        let is_post = false;
        let url = 'CA/catalogue/filter-data';
        let data = {};

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {

                Object.keys(response.data).forEach(key => {
                    if (Array.isArray(response.data[key])) {
                        response.data[key] = response.data[key].filter(
                            item => item?.value !== null
                        );
                    }
                });
                setFilterData(response.data);

                // if (!state?.editData?.id) {
                //     setProductType(response.data.product_type[0] ?? null);
                //     setSurface(response.data.surface[0] ?? null);
                //     setFinish(response.data.finish[0] ?? null);
                //     setBrand(response.data.brand[0] ?? null);
                // }

            } else { }
        });
    };

    // API - Create catalogue
    const _manageCatalogue = () => {

        // let updated_tag = tag.length !== 0 ? tag.map((data) => (data.value)) : [];

        setCreateLoader(true);

        let is_post = true;
        let url = state?.editData?.id ? 'CA/catalogue/update' : 'CA/catalogue/create';
        let data = {
            "catalogue_id": state?.editData?.id ? state?.editData?.id : undefined,
            "category": selectedProductUsage,
            "name": productName,
            "product_type": productType?.value || null,
            "surface": surface?.value || null,
            "finish": finish?.value || null,
            "brand": brand?.value || null,
            "highlight_enabled": highlightedTag === 1 ? true : false,
            "highlight_tag": highlightedTag === 1 ? tag : null,
            "thumbnail_url": thumbnail,
            "product_images": productImages[0] === null ? null : productImages,
            "display_time": selectedTime,
            "product_overview": productOverview,
            "product_title": productTitle,
            "description": productDescription,
            "brochure": brochure,
            "brochure_description": brochureDescription,
            "brochure_url": brochureFile,
            "brochure_downloadable": enableProductDownload,
            "features": productFeature,
            "redirection_title": linkTitle,
            "redirection_url": redirectionLink,
            "datasheets": dataSheetsData,
            "categories": category
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                toast.dismiss();
                toast.success(state?.editData?.id ? "Successfully updated catalogue" : "Successfully created catalogue", {
                    type: "success",
                    className: "e-toast",
                });


                navigate("/catalog", {
                    state: {
                        tab_index: selectedProductUsage
                    }
                });
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setCreateLoader(false);
        });
    };



    return (
        <section className='pb-5'>
            <div className={`e-bg-lavender-blush-light padding-12px-top padding-98px-bottom padding-52px-lr`}>
                <div className='e-display-flex justify-content-space-between'>
                    <div className='e-display-flex cursor-pointer'
                        onClick={() => navigate("/catalog", {
                            state: {
                                tab_index: state?.tab_index
                            }
                        })}>
                        <img src={require("../../../Assets/Image/CountryAdmin/arrow-left.svg").default}
                            draggable={false}
                            className='cursor-pointer'
                            alt='arrow'
                        />
                        <h1 className='ps-1 mb-0 e-primary-font-playfair e-font-24 line-height-32px e-text-rich-black e-font-weight-600'>
                            Add new product
                        </h1>
                    </div>
                </div>
            </div>

            <div className='margin-neg-66px-top padding-52px-lr'>
                <div className='e-bg-white e-admin-box-shadow p-4 e-border-radius-16 pb-5 '>
                    <h3 className='mb-4 e-primary-font-playfair e-text-raisin-black e-font-18 e-font-weight-500 line-height-28px'>
                        Add product details
                    </h3>

                    <div className='row'>
                        <div className='col-10'>
                            <div className='pb-4'>
                                <CustomRadio label="Product usage"
                                    required={true}
                                    data={PRODUCT_USAGE}
                                    className="align-items-center"
                                    selected={selectedProductUsage}
                                    onClick={(id) => setSelectedProductUsage(id)} />
                            </div>

                            <div ref={(ref) => errorFocusRef.current['productName'] = ref} >
                                <CustomTextInput label="Product name"
                                    placeholder="Add product name"
                                    type="text"
                                    require
                                    value={productName}
                                    error={productNameError}
                                    className="w-100 padding-10px-tb"
                                    // labelStyle="e-font-weight-500 e-text-raisin-black"
                                    // borderStyle="e-border-1px-platinum-light"
                                    handleChange={(e) => setProductName(e)} />
                            </div>

                            <div className='row g-3'>
                                <div className='col-6' ref={(ref) => errorFocusRef.current['productType'] = ref}>
                                    <CustomSelectBox label="Product type"
                                        value={productType}
                                        options={filterData.product_type}
                                        error={productTypeError}
                                        className="e-bg-white e-border-radius-8 e-table-select "
                                        isSearchable={false}
                                        selectChange={(value) => setProductType(value)}
                                    />
                                </div>
                                <div className='col-6' ref={(ref) => errorFocusRef.current['surface'] = ref}>
                                    <CustomSelectBox label="Surface"
                                        value={surface}
                                        options={filterData.surface}
                                        error={surfaceError}
                                        className="e-bg-white e-border-radius-8 e-table-select "
                                        isSearchable={false}
                                        selectChange={(value) => setSurface(value)}
                                    />
                                </div>
                            </div>
                            <div className='row g-3'>
                                <div className='col-6' ref={(ref) => errorFocusRef.current['finish'] = ref}>
                                    <CustomSelectBox label="Finish"
                                        value={finish}
                                        options={filterData.finish}
                                        error={finishError}
                                        className="e-bg-white e-border-radius-8 e-table-select "
                                        isSearchable={false}
                                        selectChange={(value) => setFinish(value)}

                                    />
                                </div>
                                <div className='col-6' ref={(ref) => errorFocusRef.current['brand'] = ref}>
                                    <CustomSelectBox label="Brand"
                                        value={brand}
                                        options={filterData.brand}
                                        error={brandError}
                                        className="e-bg-white e-border-radius-8 e-table-select "
                                        isSearchable={false}
                                        selectChange={(value) => setBrand(value)}
                                    />
                                </div>
                            </div>

                            <div className='pb-3 d-flex justify-content-between flex-wrap gap-2 align-items-end'>
                                <CustomRadio label="Highlight Tag"
                                    required={true}
                                    className="align-items-center"
                                    data={[{ id: 1, label: "Yes" }, { id: 2, label: "No" }]}
                                    selected={highlightedTag}
                                    onClick={(id) => setHighlightedTag(id)} />


                                <div className='d-flex align-items-center gap-2'>
                                    <Icon icon="info-icon"
                                        className="d-flex"
                                        size={16} />
                                    <p className='mb-0 e-alt-font-noto-sans e-text-indigo e-font-14 e-font-weight-400 line-height-20px'>
                                        Add a custom tag (e.g., New, Best Value) to highlight products for up to 15 days.
                                    </p>
                                </div>
                            </div>

                            {highlightedTag === 1 &&
                                <div ref={(ref) => errorFocusRef.current['tag'] = ref}>
                                    <CustomTextInput
                                        placeholder="Add tag"
                                        type="text"
                                        value={tag}
                                        error={tagError}
                                        className="w-100 padding-10px-tb"
                                        // labelStyle="e-font-weight-500 e-text-raisin-black"
                                        // borderStyle="e-border-1px-platinum-light"
                                        handleChange={(e) => setTag(e)} />

                                    {/* // <TagSelector label="Add tags"
                                //     placeholder="Add tag"
                                //     type={2}
                                //     require={true}
                                //     menuIsOpen={false}
                                //     value={tag}
                                //     error={tagError}
                                //     handleTagChange={(e) => setTag(e)} /> */}
                                </div>
                            }

                            <div ref={(ref) => errorFocusRef.current['thumbnail'] = ref} className='position-relative'>
                                <CustomFileUpload label={
                                    <div className='d-flex align-items-center justify-content-between w-100'>
                                        <div>
                                            Upload thumbnail image
                                            <span className='e-text-lust'>*</span>
                                        </div>
                                        <div className='d-flex align-items-center gap-2'>
                                            <Icon icon="info-icon"
                                                className="d-flex"
                                                size={16} />
                                            <p className='mb-0 e-alt-font-noto-sans e-text-indigo e-font-14 e-font-weight-400 line-height-20px'>
                                                Shows up on listing page
                                            </p>
                                        </div>
                                    </div>
                                }
                                    labelStyle="w-100"
                                    placeholder="Drop your image here"
                                    file={thumbnail}
                                    fileType={["JPG", "PNG", "JPEG"]}
                                    resolution="328px * 232px"
                                    // require
                                    requiredWidth={328}
                                    requiredHeight={232}
                                    errorUpdate={errorUpdate}
                                    error={thumbnailError}
                                    loader={thumbnailLoader}
                                    handleChange={_handleUploadThumbnail} />

                                {thumbnail !== null &&
                                    <TextButton name="Change file"
                                        className="position-absolute bottom--4px"
                                        onPress={() => setThumbnail(null)} />
                                }
                            </div>

                            {productImages.map((data, index) => (
                                <div className='position-relative'>
                                    <CustomFileUpload
                                        key={index}
                                        label={
                                            <div className='d-flex align-items-center justify-content-between w-100'>
                                                <div>
                                                    Upload product images
                                                    {/* <span className='e-text-lust'>*</span> */}
                                                </div>
                                                {index === 0 &&
                                                    <div className='d-flex align-items-center gap-2'>
                                                        <Icon icon="info-icon" className="d-flex" size={16} />
                                                        <p className='mb-0 e-alt-font-noto-sans e-text-indigo e-font-14 e-font-weight-400 line-height-20px'>
                                                            Shows up on detail page. Add a max of 3 images
                                                        </p>
                                                    </div>
                                                }
                                            </div>
                                        }
                                        labelStyle="w-100"
                                        placeholder="Drop your image here"
                                        file={productImages[index]}
                                        fileType={["JPG", "PNG", "JPEG"]}
                                        resolution="328px * 232px"
                                        requiredWidth={328}
                                        requiredHeight={232}
                                        errorUpdate={productImageErrorUpdate[index]}
                                        // error={productImageErrors[index]}
                                        loader={productImageLoaders[index]}
                                        handleChange={(file) => _handleUploadProductImages(file, index)}
                                    />
                                    {productImages[index] !== null &&
                                        <TextButton name="Change file"
                                            className="position-absolute bottom--4px"
                                            onPress={() =>
                                                setProductImages(prev => {
                                                    const updated = [...prev];
                                                    updated[index] = null;
                                                    return updated;
                                                })
                                            } />
                                    }


                                    {productImages.length === index + 1 && productImages.length < 3 ?
                                        < p className='mb-0 e-text-indigo e-font-16 e-alt-font-noto-sans e-font-weight-600 line-height-22px cursor-pointer position-absolute right--160px top-50'
                                            onClick={_handleAddMoreProductImage} >
                                            + <span className='cursor-pointer text-decoration-hover-underline '>Add new image</span>
                                        </p>
                                        :
                                        <p className='mb-2 text-end e-text-lust e-font-16 e-alt-font-noto-sans e-font-weight-600 line-height-22px cursor-pointer text-decoration-hover-underline position-absolute right--80px top-50'
                                            onClick={() => _handleDeleteProductImage(index)} >
                                            Delete
                                        </p>
                                    }
                                </div>
                            ))}


                            <div>
                                <label className={`mb-1 e-text-raisin-black e-alt-font-noto-sans e-font-weight-400 line-height-18px e-font-14`}>
                                    Choose image display time per slide  <span className='e-text-lust'>*</span>
                                </label>


                                <div className='d-flex align-items-center flex-wrap gap-3'>
                                    {DISPLAY_TIME.map((data, index) => (
                                        <div key={index} className='d-flex align-items-center gap-2 e-border-1px-platinum-light e-border-radius-8 padding-10px-tb padding-14px-lr e-search-box-shadow cursor-pointer'
                                            onClick={() => setSelectedTime(data.id)}>
                                            <Icon icon={selectedTime === data.id ? "radio-active" : "radio-inactive"}
                                                color="#292D32"
                                                className="d-flex"
                                                size={24} />
                                            <p className='mb-0 e-text-raisin-black e-alt-font-noto-sans e-font-weight-400 line-height-24px e-font-16'>
                                                {data.label}
                                            </p>
                                        </div>
                                    ))}

                                </div>
                            </div>
                        </div>
                    </div>


                    <div className='row pt-4 mt-2'>
                        <div className='col-10'>
                            {/* Product Overview */}
                            <div ref={(ref) => errorFocusRef.current['productOverview'] = ref}>
                                <h6 className='mb-3 e-primary-font-playfair e-text-dark-jungle-green e-font-18 e-font-weight-500 line-height-28px'>
                                    Product Overview*
                                </h6>


                                <div className='e-bg-alice-blue-dark e-border-radius-16 p-3'>
                                    <p className='mb-0 e-text-davys-grey e-alt-font-noto-sans e-font-weight-400 line-height-16px e-font-12'>
                                        Add a high-level summary of the product (e.g., its type, purpose) and its top 3-4 key selling points. This is the first thing a customer sees, so keep it concise and benefit-focused.
                                    </p>
                                </div>

                                <div className='e-bg-alice-blue-dark e-border-radius-16 pt-3 px-3 mt-4'>
                                    {/* <p className='mb-2 e-text-rasin-black e-alt-font-noto-sans e-font-weight-400 line-height-18px e-font-14'>
                                        Description
                                    </p> */}
                                    {/* <CustomEditor editorState={editor}
                                        editorStyle={{ minHeight: "200px" }}
                                        options={['inline', 'blockType', 'list', 'link', 'textAlign']}
                                        className='h-268px'
                                        error={editorError}
                                        onEditorStateChange={_handleEditorChange} /> */}
                                    {productOverview?.map((data, index) => (
                                        <div className='position-relative'>
                                            <CustomTextInput label={index === 0 ? "Description" : ""}
                                                placeholder={`Add a description ${index + 1}`}
                                                type="text"
                                                value={data}
                                                className="w-100 padding-10px-tb"
                                                handleChange={(e) => _handleOverviewChange(e, index)} />

                                            {productOverview.length === index + 1 && productOverview.length < 3 ?
                                                <p className={`${index === 0 ? "top-50" : "top-20px"} mb-0 translate-middle-y e-text-indigo e-font-16 e-alt-font-noto-sans e-font-weight-600 line-height-22px cursor-pointer position-absolute right--126px `}
                                                    onClick={_addOverview} >
                                                    + <span className='cursor-pointer text-decoration-hover-underline '>Add new</span>
                                                </p>
                                                :
                                                <p className={`${index === 0 ? "top-50" : "top-20px"} mb-0 text-end e-text-lust e-font-16 e-alt-font-noto-sans e-font-weight-600 line-height-22px cursor-pointer text-decoration-hover-underline position-absolute right--96px translate-middle-y`}
                                                    onClick={() => _removeOverview(index)} >
                                                    Delete
                                                </p>
                                            }
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Product Information */}
                            <div ref={(ref) => errorFocusRef.current['productInformation'] = ref} className='pt-4 mt-2'>
                                <h6 className='mb-3 e-primary-font-playfair e-text-dark-jungle-green e-font-18 e-font-weight-500 line-height-28px'>
                                    Product Information*
                                </h6>


                                <div className='e-bg-alice-blue-dark e-border-radius-16 p-3'>
                                    <p className='mb-0 e-text-davys-grey e-alt-font-noto-sans e-font-weight-400 line-height-16px e-font-12'>
                                        Provide a detailed product description and add any supplementary content like brochures or application guides. This section is designed to give the user a richer understanding of the product and its resources.
                                    </p>
                                </div>

                                <div className='e-bg-alice-blue-dark e-border-radius-16 p-3 mt-4'>
                                    <CustomTextInput label="Title"
                                        placeholder="Add a title"
                                        type="text"
                                        // require
                                        value={productTitle}
                                        // error={productTitleE}
                                        className="w-100 padding-10px-tb"
                                        handleChange={(e) => setProductTitle(e)} />

                                    <TextArea label="Description"
                                        placeholder="Enter your text"
                                        type="text"
                                        rows="3"
                                        value={productDescription}
                                        className="w-100 px-3 padding-10px-tb"
                                        handleChange={(e) => setProductDescription(e)} />
                                </div>


                                <div className='e-bg-alice-blue-dark e-border-radius-16 p-3 mt-4'>
                                    <div className='position-relative'>
                                        <CustomTextInput label="About Product Brochure"
                                            placeholder="Add a brochure"
                                            type="text"
                                            // require
                                            labelStyle="pb-2"
                                            value={brochure}
                                            // error={productTitleE}
                                            className="w-100 padding-10px-tb"
                                            handleChange={(e) => setBrochure(e)} />

                                        <div className='e-display-flex gap-2 align-items-center position-absolute top-0 end-0'>
                                            <p className='mb-0 e-text-indigo e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px'>
                                                Enable download
                                            </p>
                                            <label className={`${styles.e_download_enable} `} >
                                                <input type="checkbox"
                                                    checked={enableProductDownload}
                                                    onChange={(e) => setEnableProductDownload(e.target.checked)} />
                                                <span className={`${styles.e_slider}`}></span>
                                            </label>
                                        </div>
                                    </div>

                                    <TextArea label="Description"
                                        placeholder="Enter your text"
                                        type="text"
                                        rows="3"
                                        value={brochureDescription}
                                        className="w-100 px-3 padding-10px-tb"
                                        handleChange={(e) => setBrochureDescription(e)} />

                                    <div className='position-relative'>
                                        <CustomFileUpload label={"Upload image or pdf"}
                                            labelStyle="w-100"
                                            placeholder="Drop your image here"
                                            file={brochureFile}
                                            fileType={["JPG", "PNG", "JPEG", "PDF"]}
                                            support="PNG, JPG, JPEG or PDF"
                                            resolution="328px * 232px"
                                            // require
                                            requiredWidth={328}
                                            requiredHeight={232}
                                            errorUpdate={brochureFileErrorUpdate}
                                            // error={thumbnailError}
                                            loader={brochureFileLoader}
                                            handleChange={_handleUploadBrochure} />

                                        {brochureFile !== null &&
                                            <TextButton name="Change file"
                                                className="position-absolute bottom--4px"
                                                onPress={() => setBrochureFile(null)} />
                                        }
                                    </div>
                                </div>
                            </div>

                            {/* Product Features */}
                            <div ref={(ref) => errorFocusRef.current['productFeature'] = ref} className='pt-4 mt-2'>
                                <h6 className='mb-3 e-primary-font-playfair e-text-dark-jungle-green e-font-18 e-font-weight-500 line-height-28px'>
                                    Product Features*
                                </h6>


                                <div className='e-bg-alice-blue-dark e-border-radius-16 p-3'>
                                    <p className='mb-0 e-text-davys-grey e-alt-font-noto-sans e-font-weight-400 line-height-16px e-font-12'>
                                        Enter technical specifications for the product (e.g., coverage area, dry time, coats, etc.). The fields are set up for structured data that will be displayed as a list of features with icons.
                                    </p>
                                </div>

                                <div className='d-flex flex-column gap-3 mt-4'>
                                    {productFeature.map((data, index) => (
                                        <div className='position-relative e-bg-alice-blue-dark e-border-radius-16 px-3 pt-3 pb-1'>
                                            <div className='row row-cols-3 g-3'>
                                                <div className='col'>
                                                    <label className={`d-flex e-text-rich-black e-alt-font-noto-sans e-font-weight-400 line-height-18px e-font-14 padding-6px-bottom`}>
                                                        Cover image
                                                    </label>
                                                    <div style={{ height: "44px" }}>
                                                        {false ?
                                                            <div className='text-center e-border-2px-dashed-royal-blue e-bg-lavender-blue e-border-radius-8 padding-10px-tb px-1 w-100 h-100 d-flex flex-column justify-content-center align-items-center'>
                                                                <img src={require("../../../Assets/loader-dark.gif")}
                                                                    width={16}
                                                                    height={16}
                                                                    alt='loader' />
                                                            </div>
                                                            :
                                                            <div className='position-relative d-flex'>
                                                                {!data.cover_image_url ?
                                                                    <FileUploader name="file"
                                                                        types={["JPG", "PNG", "JPEG"]}
                                                                        classes="text-center cursor-pointer e-border-2px-dashed-royal-blue e-bg-lavender-blue e-border-radius-8 padding-10px-tb px-1 w-100 h-44px d-flex flex-column justify-content-center"
                                                                        children={
                                                                            <div className='d-flex align-items-center gap-2'>
                                                                                <img src={require("../../../Assets/Image/CountryAdmin/upload-icon.svg").default}
                                                                                    draggable={false}
                                                                                    alt='upload' />
                                                                                <p className='mb-0 e-text-black-chocolate e-alt-font-noto-sans e-font-12 e-font-weight-400 line-height-12px'>
                                                                                    Add your image here, or
                                                                                    <a className='ps-1 e-text-indigo cursor-pointer e-font-weight-500 text-decoration-none text-decoration-hover-underline'>
                                                                                        browse
                                                                                    </a>
                                                                                </p>
                                                                            </div>

                                                                        }
                                                                        handleChange={(e) => _handleProductFeature(e, "cover_image_url", index)} />
                                                                    :
                                                                    <div className='overflow-hidden text-center e-border-2px-dashed-royal-blue e-bg-lavender-blue e-border-radius-8 w-100 h-44px d-flex flex-column justify-content-center align-items-center'>
                                                                        <img src={data.cover_image_url}
                                                                            draggable={false}
                                                                            className='h-100 w-100 object-fit-contain'
                                                                            height={96}
                                                                            alt='thumbnail' />
                                                                    </div>
                                                                }

                                                                {data.cover_image_url &&
                                                                    <TextButton name="Change file"
                                                                        className="position-absolute bottom--16px"
                                                                        fontSize="e-font-12"
                                                                        onPress={() =>
                                                                            setProductFeature(prev => {
                                                                                const updated = [...prev];
                                                                                updated[index] = {
                                                                                    ...updated[index],
                                                                                    cover_image_url: null
                                                                                };
                                                                                return updated;
                                                                            })
                                                                        } />
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className='col'>
                                                    <CustomTextInput label="Title"
                                                        placeholder="Enter Feature 1"
                                                        type="text"
                                                        value={data.title}
                                                        className="w-100 padding-10px-tb"
                                                        handleChange={(e) => _handleProductFeature(e, "title", index)} />
                                                </div>
                                                <div className='col'>
                                                    <CustomTextInput label="Description"
                                                        placeholder="Enter your text"
                                                        type="text"
                                                        value={data.description}
                                                        className="w-100 padding-10px-tb"
                                                        handleChange={(e) => _handleProductFeature(e, "description", index)} />
                                                </div>
                                            </div>

                                            {productFeature.length === index + 1 && productFeature.length < 5 ?
                                                <p className='mb-0 e-text-indigo e-font-16 e-alt-font-noto-sans e-font-weight-600 line-height-22px cursor-pointer position-absolute right--108px top-50'
                                                    onClick={_handleAddNewFeature} >
                                                    + <span className='cursor-pointer text-decoration-hover-underline '>Add new</span>
                                                </p>
                                                :
                                                <p className='mb-2 text-end e-text-lust e-font-16 e-alt-font-noto-sans e-font-weight-600 line-height-22px cursor-pointer text-decoration-hover-underline position-absolute right--80px top-50'
                                                    onClick={() => _handleDeleteFeature(index)} >
                                                    Delete
                                                </p>
                                            }
                                        </div>
                                    ))}
                                </div>
                            </div>


                            {/* Link */}
                            <div ref={(ref) => errorFocusRef.current['link'] = ref} className='pt-4 mt-2'>
                                <h6 className='mb-3 e-primary-font-playfair e-text-dark-jungle-green e-font-18 e-font-weight-500 line-height-28px'>
                                    Link*
                                </h6>


                                <div className='e-bg-alice-blue-dark e-border-radius-16 p-3'>
                                    <p className='mb-0 e-text-davys-grey e-alt-font-noto-sans e-font-weight-400 line-height-16px e-font-12'>
                                        Enter a clear title (e.g., "How to Apply") and provide the URL for the corresponding resource. The title you add here will be a shown as a clickable link on the product information category.
                                    </p>
                                </div>

                                <div className='e-bg-alice-blue-dark e-border-radius-16  pt-3 pb-1 px-3 mt-4'>
                                    <div className='row g-3 row-cols-2'>
                                        <div className='col'>
                                            <CustomTextInput label="Title"
                                                placeholder="Add title"
                                                type="text"
                                                value={linkTitle}
                                                className="w-100 padding-10px-tb"
                                                handleChange={(e) => setLinkTitle(e)} />
                                        </div>

                                        <div className='col'>
                                            <CustomTextInput label="Redirection link"
                                                placeholder="Add link"
                                                type="text"
                                                value={redirectionLink}
                                                className="w-100 padding-10px-tb"
                                                handleChange={(e) => setRedirectionLink(e)} />
                                        </div>
                                    </div>
                                </div>
                            </div>


                            {/* Datasheets */}
                            <div ref={(ref) => errorFocusRef.current['dataSheet'] = ref} className='pt-4 mt-2'>
                                <div className='d-flex gap-32px align-items-center mb-3'>
                                    <h6 className='mb-0 e-primary-font-playfair e-text-dark-jungle-green e-font-18 e-font-weight-500 line-height-28px'>
                                        Datasheets*
                                    </h6>

                                    {/* <div className='d-flex align-items-center gap-20px'>
                                        <TextButton name="Edit"
                                            onPress={() => {
                                                setManageCategoryModal(true);
                                                setDataSheetEdit(true);
                                            }} />
                                        <TextButton name="Delete"
                                            className="e-text-lust"
                                        />
                                    </div> */}
                                </div>

                                <div className='d-flex flex-column gap-3'>
                                    {dataSheetsData.map((data, index) => (
                                        <div key={index} className='e-bg-alice-blue-dark e-border-radius-16 p-3 position-relative'>

                                            <div className='position-relative'>
                                                <CustomTextInput label="Title"
                                                    placeholder="Add a title"
                                                    type="text"
                                                    labelStyle="pb-2"
                                                    value={data.title}
                                                    className="w-100 padding-10px-tb"
                                                    handleChange={(e) => _handleChangeDataSheet(e, "title", index)} />

                                                <div className='e-display-flex gap-2 align-items-center position-absolute top-0 end-0'>
                                                    <p className='mb-0 e-text-indigo e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px'>
                                                        Enable download
                                                    </p>
                                                    <label className={`${styles.e_download_enable} `} >
                                                        <input type="checkbox"
                                                            checked={data.enable_download}
                                                            onChange={(e) => { _handleChangeDataSheet(e.target.checked, "enable_download", index) }} />
                                                        <span className={`${styles.e_slider}`}></span>
                                                    </label>
                                                </div>
                                            </div>

                                            <TextArea label="Description"
                                                placeholder="Enter your text"
                                                type="text"
                                                rows="3"
                                                value={data.description}
                                                className="w-100 px-3 padding-10px-tb"
                                                handleChange={(e) => _handleChangeDataSheet(e, "description", index)} />

                                            <div className='position-relative'>
                                                <CustomFileUpload label={"Upload image or pdf"}
                                                    labelStyle="w-100"
                                                    placeholder="Drop your image here"
                                                    file={data.file_url}
                                                    fileType={["JPG", "PNG", "JPEG", "PDF"]}
                                                    resolution="328px * 232px"
                                                    // require
                                                    requiredWidth={328}
                                                    requiredHeight={232}
                                                    errorUpdate={dataSheetFileErrorUpdate[index]}
                                                    // error={thumbnailError}
                                                    loader={dataSheetFileLoader[index]}
                                                    handleChange={(file) => { _handleChangeDataSheet(file, "file_url", index) }} />

                                                {data.file_url &&
                                                    <TextButton name="Change file"
                                                        className="position-absolute bottom--4px"
                                                        onPress={() =>
                                                            setDataSheetsData(prev => {
                                                                const updated = [...prev];
                                                                updated[index] = {
                                                                    ...updated[index],
                                                                    file_url: null
                                                                };
                                                                return updated;
                                                            })
                                                        } />
                                                }
                                            </div>

                                            {dataSheetsData.length === index + 1 && dataSheetsData.length < 5 ?
                                                <p className='mb-0 e-text-indigo e-font-16 e-alt-font-noto-sans e-font-weight-600 line-height-22px cursor-pointer position-absolute right--108px top-50 translate-middle-y'
                                                    onClick={_addDataSheet} >
                                                    + <span className='cursor-pointer text-decoration-hover-underline '>Add new</span>
                                                </p>
                                                :
                                                <p className='mb-0 text-end e-text-lust e-font-16 e-alt-font-noto-sans e-font-weight-600 line-height-22px cursor-pointer text-decoration-hover-underline position-absolute right--80px top-50 translate-middle-y'
                                                    onClick={() => _removeDataSheet(index)} >
                                                    Delete
                                                </p>
                                            }
                                        </div>
                                    ))}
                                </div>
                            </div>


                            {category.length !== 0 &&
                                <div className='pt-4 mt-2'>
                                    <div className='d-flex flex-column gap-3'>
                                        {category.map((data, index) => (
                                            <div key={index}>
                                                <div className='d-flex gap-32px align-items-center mb-3'>
                                                    <h6 className='mb-0 e-primary-font-playfair e-text-dark-jungle-green e-font-18 e-font-weight-500 line-height-28px'>
                                                        {data.title}*
                                                    </h6>

                                                    <div className='d-flex align-items-center gap-20px'>
                                                        <TextButton name="Edit"
                                                            onPress={() => {
                                                                setManageCategoryModal(true);
                                                                setDataSheetEdit(true);
                                                                setCategoryEditData(data);
                                                                setEditIndex(index);
                                                            }} />
                                                        <TextButton name="Delete"
                                                            className="e-text-lust"
                                                            onPress={() => _handleDeleteCategory(index)}
                                                        />
                                                    </div>
                                                </div>
                                                <div key={index} className='e-bg-alice-blue-dark e-border-radius-16 p-3 position-relative '>
                                                    {"category_upload_type" in data && data.category_upload_type === 2 &&
                                                        <div className='e-display-flex gap-2 align-items-center position-absolute top-16px right-16px'>
                                                            <p className='mb-0 e-text-indigo e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px'>
                                                                Enable download
                                                            </p>
                                                            <label className={`${styles.e_download_enable} `} >
                                                                <input type="checkbox"
                                                                    checked={data.enable_download}
                                                                    onChange={(e) => { _handleCategory(e.target.checked, "enable_download", index) }} />
                                                                <span className={`${styles.e_slider}`}></span>
                                                            </label>
                                                        </div>
                                                    }

                                                    {data.category_type === 1 ?
                                                        <>
                                                            {"category_name" in data &&
                                                                <CustomTextInput label="Title"
                                                                    placeholder="Add a title"
                                                                    type="text"
                                                                    labelStyle="pb-2"
                                                                    value={data.category_name}
                                                                    className="w-100 padding-10px-tb"
                                                                    handleChange={(e) => _handleCategory(e, "category_name", index)} />
                                                            }

                                                            {"description" in data &&
                                                                <TextArea label="Description"
                                                                    placeholder="Enter your text"
                                                                    type="text"
                                                                    rows="3"
                                                                    value={data.description}
                                                                    className="w-100 px-3 padding-10px-tb"
                                                                    handleChange={(e) => _handleCategory(e, "description", index)} />
                                                            }

                                                            {/* {"file_url" in data &&
                                                                <CustomFileUpload label={"Upload image or pdf"}
                                                                    labelStyle="w-100"
                                                                    placeholder="Drop your image here"
                                                                    file={data.file_url}
                                                                    fileType={["JPG", "PNG", "JPEG", "PDF"]}
                                                                    resolution="328px * 232px"
                                                                    requiredWidth={328}
                                                                    requiredHeight={232}
                                                                    errorUpdate={dataSheetFileErrorUpdate[index]}
                                                                    loader={dataSheetFileLoader[index]}
                                                                    handleChange={(file) => { _handleCategory(file, "file_url", index) }} />
                                                            } */}
                                                        </>
                                                        :
                                                        data.category_type === 2 ?
                                                            <>
                                                                {data.category_upload_type === 1 ?
                                                                    <div className='row row-cols-3 g-3'>
                                                                        <div className='col'>
                                                                            <label className={`d-flex e-text-rich-black e-alt-font-noto-sans e-font-weight-400 line-height-18px e-font-14 padding-6px-bottom`}>
                                                                                Upload img or odf
                                                                            </label>
                                                                            <div style={{ height: "44px" }}>
                                                                                {false ?
                                                                                    <div className='text-center e-border-2px-dashed-royal-blue e-bg-lavender-blue e-border-radius-8 padding-10px-tb px-1 w-100 h-100 d-flex flex-column justify-content-center align-items-center'>
                                                                                        <img src={require("../../../Assets/loader-dark.gif")}
                                                                                            width={16}
                                                                                            height={16}
                                                                                            alt='loader' />
                                                                                    </div>
                                                                                    :
                                                                                    <div className='position-relative'>
                                                                                        {!data.file_url ?
                                                                                            <FileUploader name="file"
                                                                                                types={["JPG", "PNG", "JPEG", "PDF"]}
                                                                                                classes="text-center cursor-pointer e-border-2px-dashed-royal-blue e-bg-lavender-blue e-border-radius-8 padding-10px-tb px-1 w-100 h-44px d-flex flex-column justify-content-center"
                                                                                                children={
                                                                                                    <div className='d-flex align-items-center gap-2'>
                                                                                                        <img src={require("../../../Assets/Image/CountryAdmin/upload-icon.svg").default}
                                                                                                            draggable={false}
                                                                                                            alt='upload' />
                                                                                                        <p className='mb-0 e-text-black-chocolate e-alt-font-noto-sans e-font-12 e-font-weight-400 line-height-12px'>
                                                                                                            Add your image/pdf, or
                                                                                                            <a className='ps-1 e-text-indigo cursor-pointer e-font-weight-500 text-decoration-none text-decoration-hover-underline'>
                                                                                                                browse
                                                                                                            </a>
                                                                                                        </p>
                                                                                                    </div>

                                                                                                }
                                                                                                handleChange={(e) => _handleCategory(e, "file_url", index)} />
                                                                                            :
                                                                                            <div className='overflow-hidden text-center e-border-2px-dashed-royal-blue e-bg-lavender-blue e-border-radius-8 w-100 h-44px d-flex flex-column justify-content-center align-items-center'>

                                                                                                {!data.file_url?.toLowerCase().endsWith(".pdf") ?
                                                                                                    <img src={data.file_url}
                                                                                                        draggable={false}
                                                                                                        className='h-100 w-100 object-fit-contain'
                                                                                                        height={96}
                                                                                                        alt='thumbnail' />
                                                                                                    :
                                                                                                    <p className='mb-0 p-1 e-text-rich-black e-alt-font-noto-sans e-font-16 e-font-weight-400 line-height-20px truncate-first-line w-100'>
                                                                                                        {data.file_url}
                                                                                                    </p>
                                                                                                }
                                                                                            </div>
                                                                                        }

                                                                                        {data.file_url &&
                                                                                            <TextButton name="Change file"
                                                                                                className="position-absolute bottom--16px"
                                                                                                fontSize="e-font-12"
                                                                                                onPress={() =>
                                                                                                    setCategory(prev => {
                                                                                                        const updated = [...prev];
                                                                                                        updated[index] = {
                                                                                                            ...updated[index],
                                                                                                            file_url: null
                                                                                                        };
                                                                                                        return updated;
                                                                                                    })
                                                                                                } />
                                                                                        }
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                        <div className='col'>
                                                                            <CustomTextInput label="Title"
                                                                                placeholder="Enter title"
                                                                                type="text"
                                                                                value={data.category_name}
                                                                                className="w-100 padding-10px-tb"
                                                                                handleChange={(e) => _handleCategory(e, "category_name", index)} />
                                                                        </div>
                                                                        <div className='col'>
                                                                            <CustomTextInput label="Description"
                                                                                placeholder="Enter your text"
                                                                                type="text"
                                                                                value={data.description}
                                                                                className="w-100 padding-10px-tb"
                                                                                handleChange={(e) => _handleCategory(e, "description", index)} />
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    <>
                                                                        {"file_url" in data &&
                                                                            <div className='position-relative'>
                                                                                <CustomFileUpload label={"Upload image or pdf"}
                                                                                    labelStyle="w-100"
                                                                                    placeholder="Drop your image here"
                                                                                    file={data.file_url}
                                                                                    fileType={["JPG", "PNG", "JPEG", "PDF"]}
                                                                                    resolution="328px * 232px"
                                                                                    requiredWidth={328}
                                                                                    requiredHeight={232}
                                                                                    errorUpdate={dataSheetFileErrorUpdate[index]}
                                                                                    loader={dataSheetFileLoader[index]}
                                                                                    handleChange={(file) => { _handleCategory(file, "file_url", index) }} />

                                                                                {data.file_url &&
                                                                                    <TextButton name="Change file"
                                                                                        className="position-absolute bottom--4px"
                                                                                        onPress={() =>
                                                                                            setCategory(prev => {
                                                                                                const updated = [...prev];
                                                                                                updated[index] = {
                                                                                                    ...updated[index],
                                                                                                    file_url: null
                                                                                                };
                                                                                                return updated;
                                                                                            })
                                                                                        } />
                                                                                }
                                                                            </div>
                                                                        }

                                                                    </>
                                                                }
                                                            </>
                                                            :
                                                            <div className='row g-3 row-cols-2'>
                                                                <div className='col'>
                                                                    {"category_name" in data &&
                                                                        <CustomTextInput label="Title"
                                                                            placeholder="Add title"
                                                                            type="text"
                                                                            value={data.category_name}
                                                                            className="w-100 padding-10px-tb"
                                                                            handleChange={(e) => _handleCategory(e, "category_name", index)} />}
                                                                </div>

                                                                <div className='col'>
                                                                    {"redirection_link" in data &&
                                                                        <CustomTextInput label="Redirection link"
                                                                            placeholder="Add link"
                                                                            type="text"
                                                                            value={data.redirection_link}
                                                                            className="w-100 padding-10px-tb"
                                                                            handleChange={(e) => _handleCategory(e, "redirection_link", index)} />
                                                                    }
                                                                </div>
                                                            </div>
                                                    }
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            }
                        </div>
                    </div>


                    <div className='row pt-4 mt-2'>
                        <div className='col-10'>
                            <div className='row row-cols-2 g-3'>
                                <div className='col'>
                                    <SecondaryButton name="Add a new category"
                                        className="w-100 e-text-indigo e-border-1px-indigo"
                                        onPress={() => {
                                            setManageCategoryModal(true);
                                            setDataSheetEdit(false);
                                            setCategoryEditData(null);
                                            setEditIndex(null);
                                        }} />
                                </div>
                                <div className='col'>
                                    <PrimaryButton name={state?.editData?.id ? "Save & Update" : "Add Product"}
                                        className="w-100"
                                        status={createLoader}
                                        onPress={_handleAddProduct} />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {manageCategoryModal === true &&
                <ManageCategoryModal title={dataSheetEdit ? "Edit category" : "Add new category"}
                    description={dataSheetEdit ? "Edit details." : "Add details."}
                    isEdit={dataSheetEdit}
                    editData={categoryEditData}
                    handleClose={() => {
                        setTimeout(() => {
                            setManageCategoryModal(false);
                            setDataSheetEdit(false);
                            setCategoryEditData(null);
                            setEditIndex(null);
                        }, 200);
                    }}
                    handleSuccess={_handleCategorySuccess}
                />
            }
        </section>
    )
}

export default CatalogManageProduct;
